import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SharedForAllModule } from '@base/shared-for-all.module';

import { AgeRangePipe } from '@app/baseBtl/base/pipes/age-range.pipe';
import { SinceLabelPipe } from '@app/baseBtl/base/pipes/since-label.pipe';
import { ReviewModel } from '@app/models/review.model';

import { RatingModule } from '@trilogy';

@Component({
    selector: 'btl-review-detail',
    standalone: true,
    imports: [CommonModule, RatingModule, SharedForAllModule, SinceLabelPipe, AgeRangePipe],
    templateUrl: './review-detail.component.html',
    styleUrls: ['./review-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewDetailComponent implements OnInit {
    @Input() public review: ReviewModel;

    public isLoading = false;
    public canShowMore = false;
    public showMore = false;

    public ngOnInit() {
        this.canShowMore = this.review.message.length > this.review.shortMessage.length;
    }

    public showFullMessage(): void {
        this.showMore = true;
    }
}
